const header = [
  { id: "firstName", label: "First Name" },
  { id: "lastName", label: "Last Name" },
  { id: "companyEmployeeId", label: "Company Emp ID" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
  { id: "role", label: "Role" },
  { id: "doj", label: "Date Of Joining" },
  { id: "action", label: "Action" },
];

export { header };
